import React, { useState, useRef } from "react";
import { FormWrapper } from "./FormWrapper";
import { AddAndCloseButton } from "../generic/AddAndCloseButton";
import { AddAndContinueButton } from "../generic/AddAndContinueButton";
import { CloseButton } from "../generic/CloseButton";
import { Tile } from "../generic/Tile";
import { Button } from "../generic/Button";
import { TileList } from "../generic/TileList";
import { ManageRecipeIngredients } from "./ManageRecipeIngredients";

export const ManageRecipe = ({
  onClose,
  onSubmit,
  recipes,
  mode = "add",
  recipeToEdit,
}) => {
  const [name, setName] = useState(recipeToEdit?.name || "");
  const [ingredients, setIngredients] = useState(
    recipeToEdit?.ingredients || []
  );
  const [manageIngredientsMode, setManageIngredientsMode] = useState(false);

  const nameRef = useRef(null);

  const recipeAlreadyExists = recipes.some(
    (r) => r.id !== recipeToEdit?.id && r.name === name
  );

  const removeIngredient = (ingredient) => {
    setIngredients(
      ingredients.filter(
        (existingIngredient) => existingIngredient !== ingredient
      )
    );
  };

  const handleAdd = () => onSubmit({ name, ingredients });
  const handleEdit = () => onSubmit(recipeToEdit.id, { name, ingredients });

  if (manageIngredientsMode) {
    return (
      <ManageRecipeIngredients
        onClose={() => setManageIngredientsMode(false)}
        ingredients={ingredients}
        setIngredients={setIngredients}
        removeIngredient={removeIngredient}
      />
    );
  }

  return (
    <>
      <FormWrapper>
        <div
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <h2 style={{ margin: "0 auto" }}>
            {mode === "add" ? "Neues Rezept" : "Rezept bearbeiten"}
          </h2>
          <input
            ref={nameRef}
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ fontSize: "1.5rem" }}
            autoFocus
          />

          {ingredients.length ? (
            <>
              <h3 style={{ margin: "0 auto" }}>Zutaten</h3>

              <TileList>
                {ingredients.map((ingredient) => (
                  <Tile key={ingredient}>{ingredient}</Tile>
                ))}
              </TileList>
            </>
          ) : null}

          <Button onClick={() => setManageIngredientsMode(true)}>
            Zutaten bearbeiten
          </Button>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
            }}
          >
            <AddAndCloseButton
              text={mode === "add" ? undefined : "☑️ Speichern"}
              disabled={!name || recipeAlreadyExists}
              onClick={() => {
                mode === "add" ? handleAdd() : handleEdit();
                onClose();
              }}
            />

            {mode === "add" ? (
              <AddAndContinueButton
                disabled={!name || recipeAlreadyExists}
                onClick={() => {
                  mode === "add" ? handleAdd() : handleEdit();
                  setName("");
                  nameRef.current?.focus();
                }}
              />
            ) : null}

            <CloseButton onClick={onClose} />
          </div>
        </div>
      </FormWrapper>

      {manageIngredientsMode ? (
        <ManageRecipeIngredients
          onClose={() => setManageIngredientsMode(false)}
          ingredients={ingredients}
          setIngredients={setIngredients}
          removeIngredient={removeIngredient}
        />
      ) : null}
    </>
  );
};
